<template>
  <div class="widget-anual-report">
    <div class="card center">
      <div class="card-header"><h5>Resum Anual {{ data.any }} </h5></div>
      <div class="card-body ml-3 mr-3">
          
    
          <div class="row align-items-center">
            <div class="col-2 col-sm-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.964" height="26.964" viewBox="0 0 26.964 26.964">
              <g id="Group_445" data-name="Group 445" transform="translate(-2.417 -2.417)">
                <path id="Path_122" data-name="Path 122" d="M52.5,6.3a3.387,3.387,0,1,0,3.387-3.387A3.387,3.387,0,0,0,52.5,6.3Z" transform="translate(-39.988)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_123" data-name="Path 123" d="M28.88,53.721v2.258a1.129,1.129,0,0,1-1.129,1.129H4.046a1.129,1.129,0,0,1-1.129-1.129V53.721l3.8-13.32a3.427,3.427,0,0,1,3.3-2.483H21.779a3.427,3.427,0,0,1,3.3,2.484Z" transform="translate(0 -28.227)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_124" data-name="Path 124" d="M48.265,67.083,43.75,71.6l4.515,4.515" transform="translate(-32.931 -51.749)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_125" data-name="Path 125" d="M43.75,76.114V67.083" transform="translate(-32.931 -51.749)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_126" data-name="Path 126" d="M83.265,69.341a2.258,2.258,0,0,0-4.515,0v4.515a2.258,2.258,0,0,0,4.515,0V72.728H81.572" transform="translate(-61.158 -51.749)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              </g>
            </svg>

            </div>
            <div class="col-10 col-sm-3 col-type">
              Tràfic Total
            </div>

            <div class="col-sm-5 col-6 pr-0">
              {{ data.totaltrafic }} {{ data.unitatstrafic }}
            </div>
            
            <div class="col-sm-3 col-6 pl-sm-0 col-percent">
            {{ data.inctrafic }} (any {{ data.anyanterior }})
            </div>
          </div>
      </div>
        
      <div class="card-body mr-3 ml-3" >
          
          <div class="row">
            <div class="col-2 col-sm-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="29.148" height="29.148" viewBox="0 0 29.148 29.148">
              <g id="Group_444" data-name="Group 444" transform="translate(-2.417 -2.417)">
                <g id="Group_441" data-name="Group 441" transform="translate(2.917 2.917)">
                  <rect id="Rectangle_42" data-name="Rectangle 42" width="28.148" height="13.462" rx="5.833" transform="translate(0 14.686)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_48" data-name="Line 48" y1="6.119" x2="8.567" transform="translate(2.448 8.567)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_49" data-name="Line 49" x1="7.306" y1="5.397" transform="translate(18.394 9.289)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_50" data-name="Line 50" y2="7.343" transform="translate(4.895 17.746)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_51" data-name="Line 51" y2="7.343" transform="translate(11.015 17.746)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_52" data-name="Line 52" y2="7.343" transform="translate(17.134 17.746)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_53" data-name="Line 53" y2="7.343" transform="translate(23.253 17.746)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <path id="Path_121" data-name="Path 121" d="M66.145,9.036a2.448,2.448,0,0,1-4.9,0,2.546,2.546,0,0,1,1.652-2.3A1.224,1.224,0,0,0,63.7,5.6V2.917" transform="translate(-49.012 -2.917)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                </g>
              </g>
            </svg>

            </div>
            <div class="col-10 col-sm-3 col-type">
              Tràfic de Contenidors
            </div>

            <div class="col-sm-5 col-6 pr-0">
              {{ data.totalcontenidors }} {{ data.unitatscontenidors }}
            </div>
            <div class="col-sm-3 col-6 pl-sm-0 col-percent">
              {{ data.inccontenidors }} (any {{ data.anyanterior }})
            </div>
           
          </div>
      </div>

      <div class="card-body ml-3 mr-3">
          
          
          <div class="row">
            <div class="col-2 col-sm-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="21.184" height="32.019" viewBox="0 0 21.184 32.019">
              <g id="Group_446" data-name="Group 446" transform="translate(-25.75 -2.412)">
                <path id="Path_127" data-name="Path 127" d="M36.916,3.234a.673.673,0,0,0-1.149,0c-2.138,3.5-9.517,15.871-9.517,20.6a10.092,10.092,0,0,0,20.184,0C46.434,19.105,39.054,6.737,36.916,3.234Z" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_128" data-name="Path 128" d="M55.747,113.872a6.055,6.055,0,0,1-4.274-1.749" transform="translate(-19.405 -84.019)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              </g>
            </svg>


            </div>
            <div class="col-10 col-sm-3 col-type">
              Líquids a Granel
            </div>
            <div class="col-sm-5 col-6 pr-0">
              {{ data.liquidsgranel }} {{ data.unitatsliquidsgranel }} 
            </div>
      
            <div class="col-sm-3 col-6 pl-sm-0 col-percent">
              {{ data.incliquidsgranel }} (any {{ data.anyanterior }})
            </div>
   
          </div>
      </div>

      
      <div class="card-body mr-3 ml-3">
          
          
          <div class="row">
            <div class="col-2 col-sm-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24.404" height="30.445" viewBox="0 0 24.404 30.445">
                <g id="Group_450" data-name="Group 450" transform="translate(-17 -3.489)">
                  <g id="Group_449" data-name="Group 449" transform="translate(17.5 3.989)">
                    <line id="Line_62" data-name="Line 62" x2="9.102" transform="translate(7.151 7.341)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_130" data-name="Path 130" d="M55.426,11.33a.65.65,0,0,0,.637-.572,17.579,17.579,0,0,1,1.573-4.9.65.65,0,0,0-.091-.741.637.637,0,0,0-.741-.156l-2.73,1.17L53.436,4.4a.65.65,0,0,0-1.209,0l-.7,1.729-2.717-1.17a.637.637,0,0,0-.741.156.65.65,0,0,0-.091.741,17.579,17.579,0,0,1,1.573,4.9.65.65,0,0,0,.637.572" transform="translate(-41.123 -3.989)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_131" data-name="Path 131" d="M31.8,36.925s9.1,7.151,9.1,13.405c0,6.5-5.2,8.7-11.7,8.7s-11.7-2.236-11.7-8.7c0-6.254,9.1-13.405,9.1-13.405" transform="translate(-17.5 -29.584)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  </g>
                </g>
              </svg>

            </div>

            <div class="col-10 col-sm-3 col-type">
              Sòlids a Granel
            </div>
            <div class="col-sm-5 col-6 pr-0">
              {{ data.solidsgranel }} {{ data.unitatssolidsgranel }}
            </div>

            <div class="col-sm-3 col-6 pl-sm-0 col-percent">
              {{ data.incsolidsgranel }} (any {{ data.anyanterior }})
            </div>
          </div>
      </div>

        <div class="card-body mr-3 ml-3" >
          
          
          <div class="row">
            <div class="col-2 col-sm-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="27.931" height="20.719" viewBox="0 0 27.931 20.719">
                <g id="Group_452" data-name="Group 452" transform="translate(-2.357 -20.732)">
                  <g id="Group_451" data-name="Group 451" transform="translate(2.863 21.232)">
                    <path id="Path_132" data-name="Path 132" d="M8.166,55.942H25.5a4.678,4.678,0,0,1,4.678,4.678v2.269a2.339,2.339,0,0,1-2.339,2.339h-22A2.339,2.339,0,0,1,3.5,62.889V60.62a4.678,4.678,0,0,1,4.666-4.678Z" transform="translate(-3.372 -48.983)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <circle id="Ellipse_4" data-name="Ellipse 4" cx="1.743" cy="1.743" r="1.743" transform="translate(2.443 10.444)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <circle id="Ellipse_5" data-name="Ellipse 5" cx="1.743" cy="1.743" r="1.743" transform="translate(20.992 10.444)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_133" data-name="Path 133" d="M23.683,28.238l.842-5.064a2.339,2.339,0,0,1,2.339-1.941H39.121a2.339,2.339,0,0,1,2.339,1.941l.842,5.064" transform="translate(-19.509 -21.232)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_134" data-name="Path 134" d="M18.442,102.258v1.719a1.754,1.754,0,0,1-3.509,0v-1.719" transform="translate(-12.513 -86.013)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_135" data-name="Path 135" d="M110.958,102.258v1.719a1.754,1.754,0,0,1-3.509,0v-1.719" transform="translate(-86.481 -86.013)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_136" data-name="Path 136" d="M114.042,37.049l2.012-1.17a1.747,1.747,0,0,1,1.743,3.029l-2.058,1.181" transform="translate(-91.751 -32.756)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    <path id="Path_137" data-name="Path 137" d="M7.493,37.049l-2.012-1.17a1.747,1.747,0,1,0-1.743,3.029L5.8,40.089" transform="translate(-2.863 -32.756)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  </g>
                </g>
              </svg>
            </div>

            <div class="col-10 col-sm-3 col-type">
              Automòbils
            </div>
            
            <div class="col-sm-5 col-6 pr-0">
              {{ data.automobils }} {{ data.unitatsautomobils }}
            </div>
            <div class="col-sm-3 col-6 pl-sm-0 col-percent">
              {{ data.incautomobils }}  (any {{ data.anyanterior }})      
            </div>
           
          </div>
      </div>

        <div class="card-body ml-3 mr-3" >
          
          
          <div class="row">
            <div class="col-2 col-sm-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="14.662" height="36.293" viewBox="0 0 14.662 36.293">
              <g id="Group_453" data-name="Group 453" transform="translate(-2.417 -46.167)">
                <circle id="Ellipse_6" data-name="Ellipse 6" cx="5.123" cy="5.123" r="5.123" transform="translate(4.624 46.667)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_139" data-name="Path 139" d="M9.748,78.75a6.831,6.831,0,0,0-6.831,6.831v4.554H6.332L7.471,101.52h4.554l1.138-11.385h3.415V85.581A6.831,6.831,0,0,0,9.748,78.75Z" transform="translate(0 -19.56)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              </g>
            </svg>
            </div>
            <div class="col-10 col-sm-3 col-type">
              Moviments de passatge:
            </div>
            
           <div class="col-sm-5 col-6 pr-0">
              {{data.movspassatgers}} {{ data.unitatspassatge }}
            </div>
           
           <div class="col-sm-3 col-6 pl-sm-0 col-percent">
             {{ data.inccreuristes }} (any {{ data.anyanterior }})
           </div>
          
          </div>
      </div>
        <div class="card-body ml-3 mr3" >
          
          
          <div class="row">
            <div class="col-2 col-sm-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="27.908" height="24.398" viewBox="0 0 27.908 24.398">
                <g id="Group_454" data-name="Group 454" transform="translate(-2.417 -11.167)">
                  <rect id="Rectangle_43" data-name="Rectangle 43" width="26.908" height="18.719" rx="5" transform="translate(2.917 16.346)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <path id="Path_140" data-name="Path 140" d="M49.583,16.346v-2.34a2.347,2.347,0,0,1,2.34-2.34h3.51a2.347,2.347,0,0,1,2.34,2.34v2.34" transform="translate(-37.307)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_63" data-name="Line 63" y2="18.719" transform="translate(25.145 16.346)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_64" data-name="Line 64" y2="18.719" transform="translate(21.635 16.346)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_65" data-name="Line 65" y2="18.719" transform="translate(11.106 16.346)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                  <line id="Line_66" data-name="Line 66" y2="18.719" transform="translate(7.596 16.346)" fill="none" stroke="#4d5357" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                </g>
              </svg>
            </div>
            <div class="col-10 col-sm-3 col-type">
              Moviments de creueristes
            </div>

            <div class="col-sm-5 col-6 pr-0">
              {{ data.movscreuristes }} Milions passatgers
            </div>

            <div class="col-sm-3 col-6 pl-sm-0 col-percent">
              {{ data.inccreuristes }} (any {{ data.anyanterior}})
            </div>
            
          </div>
      </div>
                        
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnualReport',
  props: {
    data: Object
  }
}
</script>